/**
 * Translations hook for react-i18next
 * Provides API compatibility with next-intl's useTranslations
 */
import { useTranslation } from "react-i18next";
import { useCallback } from "react";

type TranslationFunction = (
	key: string,
	options?: Record<string, unknown>,
) => string;

export function useTranslations(namespace?: string): TranslationFunction {
	const { t } = useTranslation();

	return useCallback(
		(key: string, options?: Record<string, unknown>) => {
			const fullKey = namespace ? `${namespace}.${key}` : key;
			return t(fullKey, options) as string;
		},
		[t, namespace],
	);
}
